import type { AnyRoute } from "@tanstack/react-router";

import { createAssetTypesRoutes } from "../../assetTypes/presentation/routes";
import { createAssetsListRoutes } from "./createAssetsListRoutes";
import type { AssetsRouteDeps } from "./assetsRouteContext";

export type { AssetsRouteDeps, AssetsRouteFactory } from "./assetsRouteContext";

export function createAssetsRoutes(deps: AssetsRouteDeps): AnyRoute[] {
  return [
    ...createAssetsListRoutes(deps),
    ...createAssetTypesRoutes({
      context: deps.context,
      assetTypes: deps.assetTypes,
      companies: deps.companies,
    }),
  ];
}
